import { render, staticRenderFns } from "./InHouseTemplate.vue?vue&type=template&id=80f7407e&scoped=true&"
import script from "./InHouseTemplate.vue?vue&type=script&lang=ts&"
export * from "./InHouseTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./InHouseTemplate.vue?vue&type=style&index=0&id=80f7407e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f7407e",
  null
  
)

export default component.exports